import React, { Suspense } from "react";
import { connect } from "react-redux";
import TemplateHeader from "../TemplateHeader/TemplateHeader";
import TemplateFooter from "../TemplateFooter/TemplateFooter";
import { insertFonts } from "../../../../../helpers/fontHelper";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import { MediaBackdrop } from "../../components/MediaBackdrop/MediaBackdrop";
import "../styles/TemplateContent.css";
import ContentWrapper from "./Wrappers/ContentWrapper/ContentWrapper";
import HeaderWrapper from "./Wrappers/HeaderWrapper/HeaderWrapper";
import FooterWrapper from "./Wrappers/FooterWrapper/FooterWrapper";

class TemplateWrapper extends React.Component {
  state = { prevBodyBGg: "", headerHeight: null };
  componentDidMount() {
    if (
      this.props.template !== undefined
    ) {
      const { template, cms } = this.props;
      this.props.dispatch(cmsActions.getClientFonts(template.eventId));
    }

  }
  componentDidUpdate(prevProps, prevState) {

    if (
      this.props.template !== undefined &&
      prevProps.template !== this.props.template
    ) {
      /*    this.setBackground(); */
      const { template, cms } = this.props;
      this.props.dispatch(cmsActions.getClientFonts(template.eventId));
    }
    if (this.headerRef !== undefined && this.state.headerRef === null) {
      this.setState({ headerHeight: this.headerRef.clientHeight });
    }

  }




  render() {
    const { template, cms, previewDevice } = this.props;
    const { editMode, fonts } = cms;
    if (template === undefined) return null;
    return (
      <div className="app">
        <MediaBackdrop
          device={previewDevice}
          url={template.content.main.youtubeUrl}
          main={template.content.main}
          enabled={template.content.main.videoBackgroundEnabled}
          editMode={editMode}
        >

          {fonts !== undefined && (
            <style
              dangerouslySetInnerHTML={{
                __html: insertFonts(this.props.cms.fonts)
              }}
            />
          )}
          <div
            style={{
              justifyContent: "center",
              width: "100%"
            }}
          >
            <div ref={r => (this.headerRef = r)} id='temp-header'>
              <HeaderWrapper>
                <TemplateHeader />
              </HeaderWrapper>
            </div>
          </div>

          <main className="not-inflicted">
            <ContentWrapper backgroundColor={this.props.backgroundColor}>{this.props.children}</ContentWrapper>
          </main>
          <div
            style={{
              justifyContent: "center",
              width: "100%"
            }}
          >
            <div ref={r => (this.footerRef = r)}>
              <FooterWrapper>
                <TemplateFooter />
              </FooterWrapper>
            </div>
          </div>
        </MediaBackdrop>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    template: state.template.template,
    previewDevice: state.template.previewDevice,
    selectedContainer: state.template.selectedContainer,
    selectedElement: state.template.selectedElement,
    cms: state.cms,
    isMenuModalOpen: state.template.isMenuModalOpen
  };
}
export default connect(mapStateToProps)(TemplateWrapper);
